<template>
  <div class="share-component" :style="wrapperStyle">
    <div class="share-banner">
      <img
        class="banner-background"
        src="https://s.thsi.cn/staticS3/mobileweb-upload-static-server.img/offline/pkg/1e014ca0-ad3f-4119-b77f-e6c6560dda5e.png"
        alt=""
      />
      <div class="banner-content">
        <img class="app-title" :src="titleImg" alt="" />
        <div v-if="dateStr" class="date-str">{{ dateStr }}</div>
      </div>
    </div>

    <div class="share-content" :class="list.length > 1 ? 'multiple-reports' : 'single-report'">
      <div v-if="publicTime" class="public-time">{{ publicTime }}</div>

      <div v-for="item in list" :key="item.symbol" class="item-wrapper">
        <div v-if="item.name" class="main-title">
          <span class="stock-name">{{ item.name }}</span
          ><span v-if="item.name" class="title-separator"></span>{{ item.title }}
        </div>

        <div v-if="hasTags(item.condition)" class="tag-list">
          <span v-for="tagText in item.condition" :key="tagText">{{ tagText }}</span>
        </div>

        <div class="content-section">
          <p>逻辑解读：</p>
          <div>{{ item.summary || '--' }}</div>
        </div>
        <div class="content-footer">内容由AI生成</div>
      </div>
    </div>

    <div class="share-footer">
      <div class="logo-wrap">
        <img
          class="ths-logo"
          src="https://s.thsi.cn/staticS3/mobileweb-upload-static-server.img/offline/pkg/d6d434be-984c-44a6-af44-d92010779388.png"
          alt=""
        />
        <div class="ths-slogan">让投资变得更简单</div>
      </div>
      <div class="qr-code">
        <div class="more-text">
          <div>长按二维码</div>
          <div>获取更多研报机会</div>
        </div>
        <img class="qr-code-img" :src="qrCode" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { getPlatform, isTrueArray } from '@king-fisher/mobileweb-lib';

import TitleCommon from '@/assets/images/yanbao-title.png';
import DailyTitle from '@/assets/images/yanbao-daily.png';
import QrCode from '@/assets/images/yanbao-qrcode.png';

export default {
  name: 'CommonShare',
  props: {
    dateStr: {
      type: String,
    },
    publicTime: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    hasTags(tags) {
      return isTrueArray(tags);
    },
  },
  computed: {
    wrapperStyle() {
      return {
        width: getPlatform() === 'iphone' ? '750px' : '375px',
        fontSize: getPlatform() === 'iphone' ? '200px' : '100px',
      };
    },
    titleImg() {
      return this.dateStr ? DailyTitle : TitleCommon;
    },

    qrCode() {
      return QrCode;
    },
  },
};
</script>

<style lang="less" scoped>
.share-component {
  text-align: left;
}

.share-banner {
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.banner-background {
  width: 3.75em;
  height: 1.21em;
}

.app-title {
  height: 0.35em;
}

.tag-list {
  display: flex;
  align-items: center;
  margin-bottom: 0.12em;

  & > span {
    padding: 0.34em 0.5em;
    margin-right: 0.67em;
    border-radius: 0.34em;
    background: rgba(51, 102, 255, 0.1);
    font-size: 0.12em;
    line-height: 1.33em;
    color: #3366ff;
  }

  .single-report & {
    margin-bottom: 0.16em;
  }
}

.single-report .content-section {
  line-height: 2em;
}

.content-section {
  font-size: 0.16em;
  line-height: 1.5em;
  white-space: pre-wrap;
}

.content-section p {
  font-weight: 500;
}

.content-footer {
  margin-top: 0.8em;
  color: rgba(0, 0, 0, 0.24);
  font-size: 0.09em;
  line-height: 1.1em;
}

.date-str {
  color: #fff;
  font-size: 0.14em;
  font-weight: 500;
  line-height: 1.28;
  margin-top: calc(1em / 1.75);
}

.banner-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  margin-top: 0.37em;
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
}

.share-content {
  position: relative;
  margin-top: -0.12em;
  padding: 0 0.16em;
  border-top-left-radius: 0.08em;
  border-top-right-radius: 0.08em;
  background-color: #ffffff;
}

.logo-wrap {
  display: flex;
  flex-direction: column;
}

.ths-logo {
  height: 0.2em;
}

.ths-slogan {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.12em;
  margin-top: calc(1em / 3);
  line-height: calc(1em * 1.333);
}

.share-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.16em;
  padding: 0.18em 0;
}

.qr-code {
  display: flex;
}

.qr-code-img {
  height: 0.48em;
  margin-left: 0.08em;
}

.more-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
  font-size: 0.12em;
  line-height: calc(1em * 1.333);
  color: rgba(0, 0, 0, 0.6);
}

.more-text div:first-child {
  margin-bottom: calc(1em / 3);
}

.item-wrapper {
  overflow: hidden;
  padding-bottom: 0.2em;
  border-bottom: 0.01em dashed rgba(0, 0, 0, 0.08);
}

.public-time {
  color: #707078;
  font-size: 0.14em;
  line-height: 1.5em;
  padding-top: 0.86em;
}

.main-title {
  color: rgba(0, 0, 0, 0.84);
  font-size: 0.2em;
  font-weight: 500;
  line-height: 1.4em;
  margin-top: 1em;
  margin-bottom: calc(1em / 1.25);

  .single-report & {
    margin-top: calc(1em / 1.25);
    margin-bottom: 1em;
  }
}

.title-separator {
  display: inline-block;
  vertical-align: -0.04em;
  margin: 0 0.5em;
  width: 0.05em;
  height: 0.7em;
  background-color: rgba(0, 0, 0, 0.24);
}
</style>
